export default {
  state() {
    return {
      //Tento objekt ti príde do BlogView, môžeš si pridať hocijaké fieldy potom máš prístup,
      //component máš required,
      //id je tiež required kvôli navigácii,
      //nový blog vytvoríš tak, že si v src/components/public/blogs vytvoríš nový blog component,
      //názov toho nového komponentu daj do component fieldu,
      //importni tento komponent v Blogview a pridaj ho do blogComponents objektu, máš tam example.
      blogs: [{
        id: 1,
        title: "heading",
        component: "BlogPost1",
        project: "TheUpside"
      }],
    }
  },

  namespaced: true,
  getters: {
    getBlogs(state) {
      return state.blogs;
    }
  }
}